var app = require('app').app;
var expand = require('lib/util').expand;

module.exports = function (interactivity, baseURL) {
    var json = interactivity.json;

    var getMetadata = require('interactivity.metadata.js');

    var m_ipcInteractivityMap = {
        dpl: [],
        def: [],
        preferredViews: [],
        sheets: {},
        options: {},
        metadata: {},
        info: []
    };

    /*
        dplid: ['itemid', ...],

        catalog: {
            options: {
                'name': 'value',
                ...
            },
            metadata: {
                'decl-id': 'value',
                ...
            },
            dpl: ['csn', ...],
            def: [['DEF_name', ...], ...],
            preferredViews: ['viewId', ...],
            children: [[row, ....], ...] // children for row
            parent: [row, ...] // parent for row
            
            sheets: { 
                'viewId': { // sheet/view
                    id: 'viewId',
                    description: '',
                    drawing: 'url',
                    items: [row, ...]
                }, 
                ...
            }
        },
    */

    var dplid = json.$('ipc/figure/dplist/item').map(function (item) {
        return item.$attr('id');
    });

    var sheetsMap = {};
    var doc = app.modelInfo || {
        sheets: json.$('ipc/figure/views/view')
            .filter(function (view) {
                return +view.$attr('hidden') === 0;
            })
            .map(function (view) {
                return {
                    id: view.$attr('id')
                };
            })
    };

    doc.sheets.forEach(function (sheet) {
        var view = json.$('ipc/figure/views/view').filter(function (view) {
            return view.$attr('id') === sheet.id;
        })[0];

        var sh = expand(sheet, {
            changed: !!+view.$attr('changed'),
            items: view.$('refItem').map(function (refItem) {
                return dplid.indexOf(refItem.$attr('ref'));
            }).sort(function (a, b) {
                return a - b;
            }),
            metadata: getMetadata(view.$('metadata/value'))
        });

        var refmedias = view.$('refmedia').filter(function (refmedia) {
            return refmedia.$attr('ref') != 1;
        });

        if (refmedias.length > 0) {
            var mediaId = refmedias[0].$attr('ref');
            var src = json.$('ipc/figure/media').filter(function (media) {
                return media.$attr('id') == mediaId;
            })[0].$attr('src');
            sh.drawing = baseURL + encodeURI(src);
        }

        sheetsMap[sheet.id] = sh;
    });

    var options = require('interactivity.options.js')(json);
    var metadata = getMetadata(json.$('ipc/figure/metadata/value'));

    var parent = json.$('ipc/figure/dplist/item').map(function (item, row, items) {
        var indent = getIndent(item) - 1;
        var parent = -1;
        for (var i = row - 1; i >= 0; i--) {
            var asp = +getMeta(items[i], 'ASP') || 0;
            var attach = +getMeta(items[i], '_301F121F8EF84EC0B9979C8D10D19A79') || 0;
            if (asp !== 1 && attach === 0) { // not attaching part
                if (getIndent(items[i]) === indent) break;
            }
        }
        for (; i >= 0; i--) {
            if (getIndent(items[i]) === indent) {
                parent = i;
                break;
            }
        }
        return parent;
    });

    var itemInfo = json.$('ipc/figure/dplist/item').map(function (item, row) {
        var info = {
            row: row
        };
        var itemMetaValues = item.$('metadata/value');
        info.id = item.$attr('id');
        info.metadata = getMetadata(itemMetaValues);
        info.part = {};
        info.part.id = item.$attr('refPart');
        var part = json.$('ipc/parts/part').reduce(function (acc, part) {
            return part.$attr('id') == info.part.id ? part : acc;
        });
        var partMetaValues = part.$('metadata/value');
        info.part.metadata = getMetadata(partMetaValues);

        info.roles = new Array(8);

        itemMetaValues.concat(partMetaValues).forEach(function (value) {
            var role = +value.$attr('role');
            if (role) {
                info.roles[role] = value.$text();
            }
        });

        info.sheetId = item.refview ? item.refview.$attr('ref') : '';
        info.screentip = item.tooltip ? item.$text('tooltip') : '';
        info.callout = item.callout ? item.$text('callout') : '';

        info.objectNames = item.$('refmedia').filter(function (refmedia) {
            return refmedia.$attr('ref') == 1;
        }).map(function (refmedia) {
            return refmedia.$text();
        });

        info.commands = item.$('commands/command').map(function (command) {
            var values = {};
            command.$('value').forEach(function (value) {
                values[value.$attr('name')] = value.$text();
            });
            return {
                id: command.$attr('id'),
                type: command.$attr('type'),
                args: command.$('value').map(function (value) {
                    return value.$text();
                }),
                values: values
            };
        });

        return info;
    });

    function normalizeCSN(s) {
        return String(s).replace(/(^\s+|\s+$)/g, '').replace(/^0+(\d)/, '$1');
    }

    function initializeDPLItemMap(interactivity) {
        if (!m_ipcInteractivityMap.dpl) {
            m_ipcInteractivityMap.dpl = json.$('ipc/figure/dplist/item').map(function (item, row) {
                var csn;
                if (typeof interactivity.willGetCSNString == 'function') {
                    csn = interactivity.willGetCSNString(itemInfo[row], row);
                } else if (itemInfo[row].callout) {
                    csn = itemInfo[row].callout;
                } else {
                    csn = itemInfo[row].roles[3] || ''; // Item number
                    csn += itemInfo[row].roles[4] || ''; // Item number variant
                }
                return csn;
            });
        }
    }

    m_ipcInteractivityMap = {
        info: itemInfo,
        def: json.$('ipc/figure/dplist/item').map(function (item, row) {
            return itemInfo[row].objectNames;
        }),
        preferredViews: json.$('ipc/figure/dplist/item').map(function (item, row) {
            return itemInfo[row].sheetId;
        }),
        sheets: sheetsMap,
        options: options,
        metadata: metadata,
        parent: parent,
        children: parent.map(function (row, index, array) {
            return array.reduce(function (acc, value, i, array) {
                return (value === index) ? acc.concat(i) : acc;
            }, []);
        })
    };

    // getMeta
    function getMeta(item, declId) {
        var metadataValues = item.$('metadata/value');
        return metadataValues.filter(function (value) {
            return value.$attr('decl-id') == declId;
        }).reduce(function (acc, value) {
            return acc + value.$text();
        }, '');
    }

    // getIndent
    function getIndent(item) {
        var indent = item.$('metadata/value').filter(function (value) {
            return value.$attr('role') == 5; // Indent
        });
        if (indent.length > 0) {
            indent = +indent[0].$text() || 0;
        }
        return indent;
    }

    var appExports = {
        ipc: {
            /**
             * The namespace represents an interface to access the information from the companion file for interactive parts catalog (IPC).
             * 
             * @namespace
             * @memberof module:solo.app.ipc
             */
            interactivity: {
                /**
                 * @name document
                 * @memberof module:solo.app.ipc.interactivity
                 * @property {XMLDocument} document The XML document for the loaded companion file.
                 */
                //document: document,

                /**
                 * JavaScript representation of the companion file *.interactivity.xml*
                 * 
                 * @name json
                 * @memberof module:solo.app.ipc.interactivity
                 * @property {XMLNodeData} json JavaScript representation of the XML file
                 * *XML:*
                 * ```
                 * <node att1="att1-value" att2="att2-value">
                 *      <foo>Foo</foo>
                 *      <bar>
                 *          <![CDATA[  Bar]]>
                 *      </bar>
                 *      <items>
                 *          <item>i1</item>
                 *          <item>i2</item>
                 *          <item>i3</item>
                 *          <item>i4</item>
                 *      </items>
                 * </node>
                 * ```
                 * *JSON:*
                 * ```
                 * {
                 *  "node": {
                 *      "@attributes": {
                 *          "att1": "att1-value",
                 *          "att2": "att2-value"
                 *      },
                 *      "foo": { "#text": "Foo" },
                 *      "bar": { "#text": "  Bar" },
                 *      "items": {
                 *          "item": [
                 *              { "#text": "i1" },
                 *              { "#text": "i2" },
                 *              { "#text": "i3" },
                 *              { "#text": "i4" }
                 *          ]
                 *      }
                 *  }
                 * }
                 * ```
                 */
                //json: json,

                /**
                 * Gets the DPL line number by the row number on the current IPC sheet.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} index The row number on the current IPC sheet
                 * @returns {number} DPL line number
                 */
                getRowByIndex: function (index) {
                    var currentSheetId = app.ipc.getCurrentSheet().id;
                    return m_ipcInteractivityMap.sheets[currentSheetId].items[index]; //-> number
                },

                /**
                 * Gets the row number on the current IPC sheet by the DPL line number.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} row DPL line number
                 * @returns {number} The row number on the current IPC sheet
                 */
                getIndexByRow: function (row) {
                    var currentSheetId = app.ipc.getCurrentSheet().id;
                    return m_ipcInteractivityMap.sheets[currentSheetId].items.indexOf(row); //-> number
                },

                /**
                 * Gets the DPL line number by the catalog sequence item number (CSN).
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {string} item CSN
                 * @returns {number} DPL line number
                 */
                getRowByItem: function (item) {
                    initializeDPLItemMap(this);
                    var csn = normalizeCSN(item),
                        len = m_ipcInteractivityMap.dpl.length,
                        i;
                    for (i = 0; i < len; i++) {
                        if (normalizeCSN(m_ipcInteractivityMap.dpl[i]) === csn) {
                            return i; //-> number
                        }
                    }
                    return -1;
                },

                /**
                 * Gets all DPL lines number by the catalog sequence item number (CSN).
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {string} item CSN
                 * @returns {number[]} DPL line numbers
                 */
                getAllRowsByItem: function (item) {
                    initializeDPLItemMap(this);
                    var csn = normalizeCSN(item),
                        i,
                        res = [];
                    for (i = 0; i < m_ipcInteractivityMap.dpl.length; i++) {
                        if (normalizeCSN(m_ipcInteractivityMap.dpl[i]) === csn) {
                            res.push(i);
                        }
                    }
                    return res;
                },

                /**
                 * Gets CSN by the DPL line number.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} row DPL line number
                 * @returns {string} CSN
                 */
                getItemByRow: function (row) {
                    initializeDPLItemMap(this);
                    return m_ipcInteractivityMap.dpl[row]; //-> string
                },

                /**
                 *  Gets the row number on the current IPC sheet by CSN.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {string} item CSN
                 * @returns {number} The row number on the current IPC sheet
                 */
                getIndexByItem: function (item) {
                    return this.getIndexByRow(this.getRowByItem(item)); //-> number
                },

                /**
                 * Gets CSN by the row number on the current IPC sheet
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} index The row number on the current IPC sheet
                 * @returns {string} CSN
                 */
                getItemByIndex: function (index) {
                    return this.getItemByRow(this.getRowByIndex(index)); //-> string
                },

                /**
                 * Gets DPL line number for the 3D object name.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {any} name The name of 3D object
                 * @returns {number} DPL line number
                 */
                getRowByObjectName: function (name) {
                    var i,
                        a = m_ipcInteractivityMap.def;
                    for (i = a.length - 1; i >= 0 ; i--) {
                        if (a[i].indexOf(name) >= 0) {
                            break;
                        }
                    }
                    return i; //-> number
                },

                /**
                 * Gets the names of 3D objects for the DPL line number.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {any} row DPL line number
                 * @returns {string[]} An array of 3D object names
                 */
                getObjectsNamesByRow: function (row) {
                    return m_ipcInteractivityMap.def[row]; //-> [name, ...]
                },

                /**
                 * Returns the URL to the 2D illustration of the IPC sheet.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {string} [id] IPC sheet identifier
                 * @returns {string} URL to the 2D illustration
                 */
                getDrawingForIPCView: function (id) {
                    id = id || app.ipc.currentSheetInfo.id;
                    var sheetInfo = m_ipcInteractivityMap.sheets[id];
                    return (sheetInfo && sheetInfo.drawing) || '';
                },

                /**
                 * Returns the IPC sheet information.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {string} [id] IPC sheet identifier
                 * @returns {CatalogSheetInfo} The object represents IPC sheet information.
                 */
                getSheetInfo: function (id) {
                    id = id || app.ipc.currentSheetInfo.id;
                    return m_ipcInteractivityMap.sheets[id];
                },

                /**
                 * Returns publication options from the companion file in form of key-value array.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @returns {KeyValuePairs} 
                 */
                getOptions: function () {
                    return m_ipcInteractivityMap.options;
                },

                /**
                 * Returns project metadata from the companion file in form of key-value array.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @returns {KeyValuePairs} 
                 */
                getProjectMetadata: function () {
                    return m_ipcInteractivityMap.metadata;
                },

                /**
                 * Gets screen tip for the object by the row number on the current IPC sheet.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} index The row number on the current IPC sheet
                 * @returns {string} Screen tip for the object
                 * @deprecated use {@link module:solo.app.ipc.interactivity.getItemInfo solo.app.ipc.interactivity.getItemInfo()} instead
                 */
                getScreenTip: function (index) {
                    var row = this.getRowByIndex(index);
                    return this.getItemInfo(row).screentip;
                },

                /**
                 * Gets preferred sheet for the object by the row number on the current IPC sheet.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} index The row number on the current IPC sheet
                 * @returns {string} Preferred IPC sheet identifier
                 * @deprecated use {@link module:solo.app.ipc.interactivity.getItemInfo solo.app.ipc.interactivity.getItemInfo()} instead
                 */
                getPrefferedSheetId: function (index) {
                    var row = this.getRowByIndex(index);
                    return this.getItemInfo(row).sheetId;
                },

                /**
                 * Returns the IPC item information.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} row DPL line number
                 * @returns {CatalogItemInfo} The object represents IPC item information
                 * @since 1.4.0
                 */
                getItemInfo: function (row) {
                    return m_ipcInteractivityMap.info[row];
                },

                /**
                 * Gets the parent for the DPL line number.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} row DPL line number
                 * @returns {number} DPL line number or -1
                 * @since 1.4.0
                 */
                getParent: function (row) {
                    return m_ipcInteractivityMap.parent[row];
                },

                /**
                 * Gets children for the DPL line number.
                 * 
                 * @memberof module:solo.app.ipc.interactivity
                 * @param {number} row DPL line number
                 * @param {boolean} [deep] Recursive
                 * @returns {number[]} Array of the DPL line number 
                 * @since 1.4.0
                 */
                getChildren: function (row, deep) {
                    var res = [];
                    var ch = m_ipcInteractivityMap.children[row];
                    var self = this;
                    if (deep) {
                        ch.forEach(function (child) {
                            res.push(child);
                            res = res.concat(self.getChildren(child, deep));
                        });
                    } else {
                        res = ch;
                    }
                    return res;
                }
            }
        }
    };

    return appExports.ipc;
};


/**
 * The hook method is invoked to get the CSN string for DPL row presented by argument.
 * Must return the CSN string for DPL row.
 * Default returns the concatenation of metadata values "Item number" and "Item number variant".
 * 
 * @memberof module:solo.app.ipc.interactivity
 * @abstract 
 * @method willGetCSNString
 * @param {CatalogItemInfo} itemInfo The object represents IPC item information
 * @param {number} row DPL line number
 * @returns {string} Returns the CSN string
 */

/**
 * The object represents the catalog item information, for example:
 * ```
 * {
 *      id: "2dc27be52b0",
 *      row: 1,
 *      metadata: {
 *          IND: "2",
 *          ITEM: "10",
 *          QNA: "1",
 *          _470D3AF1C4C540EA8EF895E86D7C147D: "2",
 *          _B479653540A9423B8170B31E38783811: ""
 *      },
 *      objectNames: [ "PM005301_1" ],
 *      part: { ... },
 *      roles: [ , "PM005301", "Back Plate Assy", "10", , "2", "1", ],
 *      screentip: "Item:10",
 *      callout: "10",
 *      sheetId: "view_2",
 *      commands: [ ... ]
 * }
 * ```
 * @prop {string} id The unique identifier of the object in the companion xml file.
 * @prop {number} row The number of DPL row.
 * @prop {KeyValuePairs} metadata Metadata of the catalog item.
 * @prop {string[]} objectNames An array of 3D object names associated with the catalog item.
 * @prop {CatalogPartInfo} part The object represents the part information.
 * @prop {string[]} roles The array of the metadata values by {@link MetadataRoleCode role number}:
 * - `0` - Undefined
 * - `1` - Part number
 * - `2` - Description for part
 * - `3` - Item number
 * - `4` - Item number variant
 * - `5` - Indent
 * - `6` - Item quantity per next higher assembly
 * - `7` - Item total quantity
 * @prop {string} screentip A string contains a brief note or label pertaining to the catalog item.
 * @prop {string} callout A string contains the CSN string for the catalog item. This is also the name of a 2D hotspot.
 * @prop {string} sheetId The identifier of the preferred catalog sheet for the catalog item.
 * @prop {DPLCommandInfo[]} commands
 * @typedef {object} CatalogItemInfo
 * @see {@link module:solo.app.ipc.interactivity.getItemInfo app.ipc.interactivity.getItemInfo()}
 */

/**
 * The object represents the command information, for example:
 * ```
 * {
 *      id: "233f0c80570",
 *      type: "MODAPPLY",
 *      args: [ "A B" ],
 *      values: { 
 *          "MODEL APPLY CODES": "A B"
 *      }
 * }
 * ```
 * @prop {string} id The unique identifier of the object in the companion xml file.
 * @prop {string} type The name of the command.
 * @prop {string[]} args Array of arguments of the command.
 * @prop {KeyValuePairs} Arguments of the command by name.
 * @typedef {object} DPLCommandInfo
 * @see CatalogItemInfo
 */


/**
 * The object represents the part information, for example:
 * ```
 * {
 *      id: "2dc27a27920",
 *      metadata: {
 *          DFP: "Back Plate Assy",
 *          PNR, "PM005301"
 *      }
 * }
 * ```
 * @prop {string} id The unique identifier of the object in the companion xml file.
 * @prop {KeyValuePairs} metadata Metadata of the catalog part.
 * @typedef {object} CatalogPartInfo
 * @see CatalogItemInfo
 */

/**
 * The object represents the IPC sheet information, for example:
 * ```
 * {
 *      id: "view_0",
 *      description: "Assembled View",
 *      drawing: "http://.../pump-catalog-1.svg",
 *      indentationLevel: 0,
 *      items: [0,1,13,28],
 *      metadata: {
 *          APPLICREFIDPAGE: "app-01"
 *      }
 * }
 * ```
 * @prop {string} id - IPC sheet ID. 
 * @prop {string} description - IPC sheet description.
 * @prop {string} drawing - The name of the file for 2D illustration.
 * @prop {number} indentationLevel - The indentation level that indicates IPC sheets relationships.
 * @prop {number[]} items - An array of row numbers of the DPL table active on this sheet.
 * @prop {KeyValuePairs} metadata Metadata for the IPC sheet.
 * @prop {boolean} changed
 * @typedef {object} CatalogSheetInfo
 * @see DocumentCatalogInfo
 * @see {@link module:solo.app.ipc.interactivity.getSheetInfo app.ipc.interactivity.getSheetInfo()}
 */